import React from "react";
import { CheckboxIcon } from "@sonder/ui/source/styled/fragments/CheckboxIcon";
import { CheckboxWithLabel } from "@sonder/ui/source/styled/fragments/CheckboxWithLabel";
import { FilterGroupItem } from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { DispatchRoleName } from "typings/globalGQLTypes";

export const mapNameToDisplayName = (name: DispatchRoleName) => {
  switch (name) {
    case DispatchRoleName.hk_contractor:
      return "HK Contractor";
    case DispatchRoleName.hk_manager:
      return "Cleaning Company Manager";
    case DispatchRoleName.housekeeper:
      return "Housekeeper";
    case DispatchRoleName.tom_manager:
      return "Manager";
    case DispatchRoleName.tom_team_lead:
      return "Team Lead";
    default:
      return "";
  }
};

interface RoleFilterGroupItemProps {
  isChecked: boolean;
  onClick(): void;
  role: DispatchRoleName;
}

export const RoleFilterGroupItem = ({
  isChecked,
  onClick,
  role,
}: RoleFilterGroupItemProps) => {
  return (
    <FilterGroupItem fullWidth noBorder type="button" onClick={onClick}>
      <CheckboxWithLabel title={role}>
        <CheckboxIcon checked={isChecked} />
        <Label>{mapNameToDisplayName(role)}</Label>
      </CheckboxWithLabel>
    </FilterGroupItem>
  );
};
